import { render, staticRenderFns } from "./SgcqTabsPanel.vue?vue&type=template&id=fe80415a&scoped=true"
import script from "./SgcqTabsPanel.vue?vue&type=script&lang=js"
export * from "./SgcqTabsPanel.vue?vue&type=script&lang=js"
import style0 from "./SgcqTabsPanel.vue?vue&type=style&index=0&id=fe80415a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe80415a",
  null
  
)

export default component.exports